export default __webpack_public_path__ + "assets/ecuador-flag.png";